export interface Storage {
  getItem(key: string): string | null
  removeItem(key: string): void
  setItem(key: string, value: unknown): void
}

export interface ObjectStorage {
  getItem(key: string): unknown | null
  removeItem(key: string): void
  setItem(key: string, value: unknown): void
}

export const localStorage = getStorage(window.localStorage)
export const sessionStorage = getStorage(window.sessionStorage) as Storage

/**
 * Creates an object storage that serializes and deserializes JSON.
 */
export function createObjectStorage(
  storage: Storage,
  prefix = ''
): ObjectStorage {
  return {
    getItem(key: string) {
      const got = storage.getItem(prefix + key)
      if (!got) {
        return null
      }

      return JSON.parse(got)
    },
    setItem(key: string, value: unknown | null) {
      if (value === null || value === undefined) {
        return storage.removeItem(prefix + key)
      }
      storage.setItem(prefix + key, JSON.stringify(value))
    },
    removeItem(key: string) {
      storage.removeItem(prefix + key)
    },
  }
}

// In Private Mode on iOS, setting items in the storage fails.
// We wrap it to make sure we can make it at least not crash.
function getStorage(storage: globalThis.Storage): Storage {
  try {
    storage.setItem('supported', 'true')
    storage.removeItem('supported')
  } catch (err) {
    const map = new Map()
    return {
      getItem: (item: any) => {
        const r = map.get(item)
        return r === undefined ? null : r
      },
      setItem: (item: any, value: any) =>
        map.set(
          item,
          value === undefined || value === null ? value : value.toString()
        ),
      removeItem: (item: any) => map.delete(item),
    }
  }
  return storage as Storage
}
